import { capitalize } from "@jutro/tools";
import { Checkbox } from "@jutro/ui";
import { Controller, useFormContext } from "react-hook-form";
import { IpomFormSchema } from "components/IpomForm/schema";
import { Loader } from "components/new";
import { useDoctorGetIpomSpecialistsQuery } from "lib/graphql/megaSchema";
import { useGetPatientId } from "lib/hooks/useGetPatientId";

type Props = {
  disabled?: boolean;
};

export const SpecialistVisitsSection = ({ disabled }: Props) => {
  const { control } = useFormContext<IpomFormSchema>();

  const patientId = useGetPatientId();

  const { data, loading } = useDoctorGetIpomSpecialistsQuery({
    variables: {
      patientId: patientId ?? "",
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (!data || data.doctorGetIpomSpecialists.length === 0) {
    return (
      <div>
        Brak specjalistów do wyświetlenia. Ściezka OK nie jest włączona w
        wojewodzie pacjenta.
      </div>
    );
  }

  const specialistVisitsOptions = data.doctorGetIpomSpecialists
    .toSorted()
    .map((specialist) => ({
      label: capitalize(specialist.toLowerCase()),
      value: specialist,
    }));

  return (
    <>
      <span className="font-label text-jutro-new-warm-gray-800">
        Konsultacje pacjenta ze specjalistą
      </span>

      <div className="flex flex-col rounded-lg bg-jutro-new-warm-gray-50 p-4">
        {specialistVisitsOptions.map((option) => (
          <Controller
            key={option.value}
            control={control}
            name="specialistVisits"
            render={({ field: { onChange, value, ...restField } }) => (
              <Checkbox
                {...restField}
                disabled={disabled}
                checked={value.some((v) => v === option.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    onChange([...value, option.value]);
                    return;
                  }

                  onChange(value.filter((v) => v !== option.value));
                }}
                label={option.label}
              />
            )}
          />
        ))}
      </div>
    </>
  );
};
